<template>
  <div
    v-if="isVisible"
    class="modal confirmation-modal"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    aria-labelledby="confirmationModalLabel"
    @keydown.esc="closeModal"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="confirmationModalLabel" class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="閉じる"
            :disabled="isSubmitting"
            @click="closeModal"
          ></button>
        </div>

        <div class="modal-body">
          <p class="mb-0 preserve-lines">{{ description }}</p>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            :disabled="isSubmitting"
            @click="closeModal"
          >
            キャンセル
          </button>
          <button
            ref="confirmButton"
            type="button"
            class="btn"
            :class="confirmButtonClass"
            :disabled="isSubmitting"
            @click="confirm"
          >
            {{ isSubmitting ? submittingLabel : confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick, ref } from 'vue';

export default {
  props: {
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm'],
  setup(props, { emit }) {
    const isVisible = ref(false);
    const action = ref('');
    const title = ref('確認');
    const description = ref('');
    const confirmLabel = ref('実行する');
    const submittingLabel = ref('処理中...');
    const confirmButtonClass = ref('btn-primary');
    const confirmButton = ref(null);

    const show = (options) => {
      action.value = options.action;
      title.value = options.title || '確認';
      description.value = options.description || '';
      confirmLabel.value = options.confirmLabel || '実行する';
      submittingLabel.value = options.submittingLabel || '処理中...';
      confirmButtonClass.value = options.confirmButtonClass || 'btn-primary';
      isVisible.value = true;

      nextTick(() => confirmButton.value?.focus());
    };

    const closeModal = () => {
      if (props.isSubmitting) return;
      isVisible.value = false;
    };

    const confirm = () => {
      if (props.isSubmitting) return;
      emit('confirm', { action: action.value });
    };

    return {
      isVisible,
      title,
      description,
      confirmLabel,
      submittingLabel,
      confirmButtonClass,
      confirmButton,
      show,
      closeModal,
      confirm
    };
  }
};
</script>

<style scoped>
.confirmation-modal {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-dialog {
  max-width: 520px;
}

.preserve-lines {
  white-space: pre-line;
}
</style>
